import styled from "@emotion/styled";
import * as React from "react";
import { FC } from "react";
import FlexBox, { CustomWidthE } from "../../../components/FlexBox";
import { rem } from "../../../styling/theme";
import {
  AnimationOverlay,
  Avatar,
  CardWrapper,
  Line,
} from "../PlaceholderLoader";

const Wrapper = styled(FlexBox)({
  position: "relative",
  width: "100%",
  borderRadius: rem(16),
  overflow: "hidden",
});

const ConversationCardPlaceholder: FC<{}> = () => (
  <Wrapper customWidth={CustomWidthE.full}>
    <CardWrapper customWidth={CustomWidthE.full}>
      <AnimationOverlay />
      <FlexBox customWidth={CustomWidthE.full} alignItems="flex-start">
        <Avatar />
        <FlexBox
          customWidth={CustomWidthE.full}
          flexDirection="column"
          alignItems="flex-start"
        >
          <Line />
          <Line />
          <Line last={true} />
        </FlexBox>
      </FlexBox>
    </CardWrapper>
  </Wrapper>
);

export default ConversationCardPlaceholder;
